;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    page_title: {
      type: String,
      default: "Wallets"
    },
    success_message: {
      type: String,
      default: "Successfully submitted!"
    }
  },
  data: function data() {
    return {
      default_message: "Your withdrawal request has been submitted and is being processed.",
      default_title: "Withdrawal Submitted"
    };
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh","display":"flex","align-items":"center","justify-content":"center","background":"#f9fafb","padding":"24px"}},[_c('div',{staticClass:"ac-login-card",staticStyle:{"border-color":"#dfdfdf","text-align":"center"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"center","margin-bottom":"20px"}},[_c('div',{staticStyle:{"width":"56px","height":"56px","border-radius":"50%","background":"#ecfdf5","display":"flex","align-items":"center","justify-content":"center"}},[_c('svg',{attrs:{"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 14L11 20L23 8","stroke":"#059669","stroke-width":"2.5","stroke-linecap":"round","stroke-linejoin":"round"}})])])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"18px","font-weight":"600","color":"#101828","margin":"0 0 8px"}},[_vm._v("\n      "+_vm._s(_vm.page_title)+"\n    ")]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"14px","font-weight":"400","color":"#475467","line-height":"22px","margin":"0 0 32px"}},[_vm._v("\n      "+_vm._s(_vm.message)+"\n    ")]),_vm._v(" "),_vm._m(0)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('a',{staticClass:"ac-btn-primary",staticStyle:{"text-decoration":"none"},attrs:{"href":"/wallet/checkout"}},[_vm._v("Back to Wallets")])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dbc8d142", __vue__options__)
  } else {
    hotAPI.reload("data-v-dbc8d142", __vue__options__)
  }
})()}